/* eslint-disable indent,import/prefer-default-export,no-restricted-globals,space-infix-ops */
import fr from 'facet-rest';


const HoldingOverride = fr.metaOverride().overrideAll({ hidden: true })
  .nameOverride('name', { ordinal: 0, hidden: false })
  .nameOverride('ticker', { ordinal: 1, hidden: false })
  .nameOverride('tickerClassification', { ordinal: 2, hidden: false })
  .nameOverride('type', { ordinal: 3, hidden: false })
  .nameOverride('costBasis', { ordinal: 4, hidden: false })
  .nameOverride('currentPrice', { ordinal: 5, hidden: false })
  .nameOverride('quantity', { ordinal: 6, hidden: false })
  .nameOverride('expenseRatio', { ordinal: 7, hidden: false });

export default HoldingOverride;
